// extracted by mini-css-extract-plugin
module.exports = {"messageContainer":"styles-module__messageContainer___3UEXR","checkInbox":"styles-module__checkInbox___n84Uy"};